import filters from "../../../assets/filters.svg";

/**
 * FilterButton component - Handles filter toggle functionality
 *
 * Features:
 * - Toggles filter panel visibility
 * - Disabled when no image selected and camera has errors
 * - Shows filters icon with proper styling
 * - Provides contextual tooltips for user guidance
 */
const FilterButton = ({ 
  onToggle,           // Function to call when button is clicked
  selectedImages,      // Currently selected/captured image (if any)
  cameraError         // Current camera error state (if any)
}) => {
  /**
   * Handles button click with conditional logic
   * - Allows toggle if there's a selected image OR no camera errors
   * - Prevents toggle if camera has errors AND no image is selected
   */
  const handleClick = () => {
    // Only allow toggle if there's a selected image or no camera errors
    if (selectedImages?.length || !cameraError) {
      onToggle();
    }
  };

  return (
    <button
      onClick={handleClick}
      className="filters-btn"
      title={
        cameraError && !selectedImages?.length
          ? "Filters unavailable due to camera error"
          : "Toggle filters"
      }
    >
      {/* Filters icon - indicates filter functionality */}
      <img src={filters} alt="filters" />
    </button>
  );
};

export default FilterButton;
